// extracted by mini-css-extract-plugin
module.exports = {"loader":"orders_loader__oJ_yq","cardHeader":"orders_cardHeader__aFgpx","eyeicon":"orders_eyeicon__zwaM4"};